// pages/.../WarehouseDataTable.tsx
import React from 'react';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { WarehouseDataForm, WarehouseFilters } from '../../../../app/models/Warehouse';
import useWarehouseService from '../../../../app/services/hooks/useWarehouseService';

interface Props {
  warehouses: WarehouseDataForm[];
  totalRows: number;
  loading?: boolean;
  edit?: (id: number) => void;
  show?: (id: number) => void;
  destroy?: (id: number) => void;
  filter: WarehouseFilters;
  setFilter: (filter: WarehouseFilters) => void;
  callbackSuccess: () => void;
}

const WarehouseSwitchChange: React.FC<{
  checkValue?: boolean;
  warehouseId: number;
  callbackSuccess: () => void;
}> = ({ checkValue, warehouseId, callbackSuccess }) => {
  const { activeWarehouse } = useWarehouseService();
  return (
    <div className="form-check form-switch">
      <input
        type="checkbox"
        className="form-check-input"
        checked={!!checkValue}
        onChange={(e) => {
          activeWarehouse(warehouseId, e.target.checked, {
            onSuccess: () => callbackSuccess(),
            onError: () => callbackSuccess()
          });
        }}
      />
    </div>
  );
};

const WarehouseDataTable = ({
  warehouses, totalRows, loading = false, edit, show, destroy, filter, setFilter, callbackSuccess
}: Props) => {
  const columns = [
    { name: 'Id', selector: (row: any) => row.id, sortable: true, sortField: 'id',
      cell: (row: WarehouseDataForm) => <span>{row.id}</span> },

    { name: 'Tipo', selector: (row: any) => row.warehouse_type_label ?? row.warehouse_type, sortable: true, sortField: 'warehouse_type',
      cell: (row: WarehouseDataForm) => <span>{row.warehouse_type_label ?? row.warehouse_type}</span> },

    { name: 'Nombre', selector: (row: any) => row.name, sortable: true, sortField: 'name',
      cell: (row: WarehouseDataForm) => <span>{row.name}</span> },

    { name: 'Centro', selector: (row: any) => row.center, sortable: true, sortField: 'center__name',
      cell: (row: WarehouseDataForm) => <span>{row.center}</span> },

    { name: 'Estado', selector: (row: any) => row?.is_active, sortable: true, sortField: 'is_active', width: '100px',
      cell: (row: WarehouseDataForm) => (
        <WarehouseSwitchChange
          checkValue={row.is_active ?? true}
          warehouseId={row.id ?? -1}
          callbackSuccess={callbackSuccess}
        />
      ) },

    {
      name: 'Acciones',
      selector: (row: any) => row.id,
      sortable: false,
      cell: (row: WarehouseDataForm) => (
        <div>
          {show && <ButtonTableAction callbackFunction={() => show(row.id ?? -1)} classIcon="mdi mdi-eye" colorIcon="text-info" title="Ver" />}
          {edit && <ButtonTableAction callbackFunction={() => edit(row.id ?? -1)} classIcon="mdi mdi-pencil" colorIcon="text-warning" title="Editar" />}
          {destroy && <ButtonTableAction callbackFunction={() => destroy(row.id ?? -1)} classIcon="mdi mdi-delete" colorIcon="text-danger" title="Eliminar" />}
        </div>
      )
    }
  ];

  return (
    <>
      <div className="row mt-3"><div className="col">{/* (Opcional) filtros visibles aquí */}</div></div>
      <DefaultDataTable
        columns={columns}
        data={warehouses}
        progressPending={loading}
        paginationTotalRows={totalRows}
        filter={filter}
        setFilter={setFilter}
      />
    </>
  );
};

export default WarehouseDataTable;
